import { parse as parseUrl } from 'url';
import fetch from 'isomorphic-fetch';
import Debug from 'debug';

const debug = Debug('rs:store/middleware/api/fetch');

/**
 * A wrapper around fetch() that supports installing 'interceptor'
 * hooks which can override or augment a network response.
 *
 * This is useful for mocking or augmenting a response when a
 * feature is in development and the API dependencies
 * aren't in place yet.
 *
 * An 'interceptor' is just a function that accept `fetch()`
 * arguments and returns a `Response` object, so you can
 * do whatever you want.
 */
class Fetch {
  static getPathName = (url) => parseUrl(url).pathname;

  interceptors = {};

  /**
   * Install an interceptor hook.
   *
   * NOTE: doesn't support pattern matching yet.
   *
   * @param {String} path - the endpoint path to intercept
   * @param {Function} loader - a loader/import function for an interceptor
   */
  intercept(path, loader) {
    this.interceptors[path] = loader;
  }

  async fetch(url, options) {
    debug('fetch', url);
    const pathname = parseUrl(url).pathname;
    const interceptor = this.interceptors[pathname];

    // when no interceptor for endpoint, use normal fetch()
    if (!interceptor) {
      return fetch(url, options);
    }

    debug('using "%s" interceptor', url);
    return interceptor(url, options);
  }
}

export default Fetch;
